/**
  * @class meleActorSpeed
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-speed>` custom web element for playing GPS speed from mmGps in <mele-channel>
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
  round: { description: 'round speed to this number of digits', type: 'number', default: 1 },
}, meleActor._properties)

export default class meleActorSpeed extends meleActor {
  init() {
    super.init()
    this.appendChildren({
      tag: 'mele-text',
      class: 'title',
      label: 'doppler.gps_speed',
    })
    this.elSpan = this.appendChildren({
      tag: 'span',
      class: 'subtitle',
      html: '-',
    })
    this.classList.add('indicator')
  } // init

  message({ action, params }) {
    if(action === 'mmGps') {
      const round = _.natural(this.round)
      this.elSpan.innerHTML = `${Number(params.speed).toFixed(round)} km/h`
    }
  } // message
} // class meleActorSpeed

meleActorSpeed._properties = PROPERTIES
meleActorSpeed.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-speed', meleActorSpeed)
